<ng-http-loader [backdrop]="false" [backgroundColor]="'#ff0000'" [debounceDelay]="400" [extraDuration]="100"
  [minDuration]="100" [opacity]=".6" [filteredUrlPatterns]="['documents/export-documents']">
</ng-http-loader>

<mat-toolbar color="primary">



  <span routerLink="/home"><span class="application-logo"><img src="assets/images/calwatrs-logo.png" alt="CalWATRS"
        height="45"></span>

  </span>
  <span class="menu-spacer"></span>
  <div class="menu" *ngIf="configSection" class="ml-5">Configure Repository</div>
  <div class="menu" *ngIf="currentUser && !configSection">

    <a class="menubuttons" [routerLink]="'/home'" routerLinkActive="selected">Basic Search</a>
    <a class="menubuttons" *ngIf="aclGroup.fileInbox.dashboard" [routerLink]="'/fileInbox'" routerLinkActive="selected">File Inbox</a>
    <a class="menubuttons" *ngIf="aclGroup.browse.dashboard" [routerLink]="'/categories'" routerLinkActive="selected"> Browse </a>
    <a class="menubuttons" *ngIf="aclGroup.folders" [routerLink]="'/folders'" routerLinkActive="selected"> Folders </a>
    <a class="menubuttons" *ngIf="aclGroup.metadataSearch" [routerLink]="'/search'" routerLinkActive="selected"> Metadata Search </a>
    <a class="menubuttons" *ngIf="aclGroup.metadataSearch" [routerLink]="'/legacyIndex'" routerLinkActive="selected"> Bulk Metadata Update</a> 
    <a class="menubuttons" *ngIf="aclGroup.browse.dashboard" [routerLink]="'/deduplication'" routerLinkActive="selected"> Duplication</a>    
    <!-- <a *ngIf="aclGroup.taskQueues && enableWorkflow" class="menubuttons" [routerLink]="'/taskInbox'" routerLinkActive="selected"> Task Queues

    </a> -->

    <!-- <a *ngIf="aclGroup.glacier && archive" class="menubuttons" [routerLink]="'/glacierStatus'" routerLinkActive="selected"> Glacier

      Status</a> -->

    <!-- <a class="menubuttons" [routerLink]="'/insights'" routerLinkActive="selected"> Insights </a> -->
    <a class="menubuttons" [routerLink]="'/export'" routerLinkActive="selected"> Status </a>

  </div>
  <!--<div class="menu" *ngIf="configSection">
      <a class="settingsbuttons" [routerLink]="'/config/category'" routerLinkActive="selected"> Category Configuration</a>
      <a class="settingsbuttons" [routerLink]="'/config/search'" routerLinkActive="selected"> Search Configuration</a>
      <a class="settingsbuttons" [routerLink]="'/categoryconfig'" routerLinkActive="selected"> Compliance</a>
    </div>-->
  <!-- This fills the remaining space of the current row -->
  <span class="fill-remaining-space"></span>
  <div *ngIf="aclGroup.search && currentUser && router.url!='/home'" class="toolbar-buttons">
    <div *ngIf="!openSearch" class="col-2">
      <button mat-button (click)="initiateSearch()" class="searchButton">
        <mat-icon style="margin-right: 0em;">search</mat-icon>
        Search
      </button>
    </div>
    <div *ngIf="openSearch">

      <form (ngSubmit)="fullTextSearch()">
        <mat-icon (click)="fullTextSearch()" style="margin-right: 8px;">search</mat-icon>

        <mat-form-field appearance="standard">
          <input matInput name="search-text" style="margin-right: 8px; font-size: 16px;" type="text"
            [(ngModel)]="searchText" placeholder="Search">
        </mat-form-field>
        <mat-icon (click)="cancel()">close</mat-icon>
      </form>
    </div>
  </div>
  <span class="toolbar-buttons" *ngIf="currentUser">

    <mat-icon routerLink="/config/home" routerLinkActive="active" title="Configure Repository"
      *ngIf="aclGroup.settings.dashboard && !configSection && admin">

      settings</mat-icon>

    <mat-icon routerLink="/home" routerLinkActive="active" title="Home" *ngIf="configSection">

      home</mat-icon>

    <button mat-button *ngIf="aclGroup.signinMenu.dashboard && shouldDisplayUserIcon" #authMenu
      class="mat-fab auth-menu" [matMenuTriggerFor]="menu"
      title="{{currentUser.username}} {{currentUser.lastName}}"><span
        class="user-initials">{{getUserInitials()}}</span></button>

    <!-- <ngx-avatar name="{{currentUser.username}}" title="{{currentUser.username}}" [matMenuTriggerFor]="menu"></ngx-avatar> -->

    <mat-menu #menu="matMenu">
      <button mat-menu-item>{{currentUser.username}}</button>

      <!-- <button mat-menu-item (click)="logout();">Sign out</button> -->

    </mat-menu>
  </span>
</mat-toolbar>


<alert></alert>
<router-outlet></router-outlet>


<div class="application-version-number">
  version_{{APP_VERSION}}
</div>
